<template>
   <div class="inline">
     <div>
      <p v-on:mouseover="hover(true)" v-on:mouseout="hoverOut" class="text-xs">
        <span v-if="popUpUser.status === 'In Progress'" class="moodle-result inprogress">{{userAssociatedText}}</span>
        <span v-else-if="popUpUser.status === 'Completed'" class="moodle-result moodle-result completed">{{userAssociatedText}}</span>
        <span v-else-if="popUpUser.status === 'Expired'" class="moodle-result expired">{{userAssociatedText}}</span>
        <span v-else class="moodle-result">{{userAssociatedText}}</span>
      </p>
     </div>
      <div class="user-popover rounded-lg ml-6 p-3 px-4"  transition="fade" v-on:mouseover="hoverInfo" v-on:mouseout="hoverOutInfo" v-if="showPopup">
        <div class="flex flex-col scrollbar  text-left text-xs align-top w-48">
          <p class="mb-2">{{popUpUser.course_name}}</p>
          <p class="mb-2">Status: {{popUpUser.status}}</p>
          <p class="mb-2">Start date: <span v-if="popUpUser.first_accessed_at">{{ popUpUser.first_accessed_at | date }}</span><span v-else>N/A</span></p>
          <p class="mb-2">Progress: {{popUpUser.progress}}%</p>
          <p class="mb-2">Completion date: <span v-if="popUpUser.completed_at">{{ popUpUser.completed_at |date }}</span><span v-else>N/A</span></p>
        </div>
      </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: [
    'userAssociatedText', 'popUpUser'
  ],
  data () {
    return {
      showPopup: false,
      timer: '',
      isInInfo: false
    }
  },
  methods: {
    ...mapActions([
      'displayToastNotification'
    ]),
    hover (check) {
      if (!check) {
        return
      }
      let vm = this
      this.timer = setTimeout(function () {
        vm.showPopover()
      }, 600)
    },

    hoverOut () {
      let vm = this
      clearTimeout(vm.timer)
      this.timer = setTimeout(function () {
        if (!vm.isInInfo) {
          vm.closePopover()
        }
      }, 200)
    },

    hoverInfo () {
      this.isInInfo = true
    },

    hoverOutInfo () {
      this.isInInfo = false
      this.hoverOut()
    },

    showPopover () {
      this.showPopup = true
    },

    closePopover () {
      this.showPopup = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .inline{
    display: inline-block;
    position: relative;
  }
  .user-popover{
    position: absolute;
    left: 60%;
    bottom: -90%;
    background: #707070;
    border: 1px solid #fff;
    color: #fff;
    z-index:999;
  }

  .scrollbar {
    scrollbar-width: 1px; /* for Firefox */
    overflow-x: scroll !important;
  }

  .user-popover:before {
  content:"";
    position: absolute;
    height: 0px;
    width: 0px;
    bottom: 10px;
    left: -29px; /* 1px buffer for zooming problems while rendering*/
    border-width: 15px;
    border-color: transparent #707070 transparent transparent;
    border-style: solid;
  }
  .moodle-result {
      width: 30px;
      height: 30px;
      line-height: 30px;
      border-radius: 50%;
      text-align: center;
      vertical-align: middle;
      background: #CCC;
      color: #333;
      display: inline-block;
  }
  .moodle-result.completed {
      background: #5CB85C;
      color: #FFF;
  }
  .moodle-result.inprogress {
      background: #f2c605;
      color: #FFF;
  }
  .moodle-result.expired {
      background: #e67e22;
      color: #FFF;
  }
</style>
